import styled, { css } from 'styled-components'
import { Divider as DividerAnt } from 'antd'
import {
  Label, Icon, H4, P,
} from 'konsys-ui'
import { theme, media } from '../../styles/_variables'

export const RadioInput = styled.input`
  display: none;
`

export const RadioLabel = styled.label`
  width: 30px;
  height: 30px;
  border: 1px solid ${theme.color.paleGrey};
  background-color: ${theme.color.offWhite};
  border-radius: 30px;
  cursor: pointer;
  margin: 0;
  &:before {
    content: '';
    font-family: 'Font Awesome 5 Pro';
    font-weight: 300;
    font-size: 16px;
    line-height: 1.8;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
  }
  ${props => props.img && css`
    &:before {
      content: '';
      background-image: url(${props.img});
      background-size: cover;
      width: 63px;
      height: 63px;
      border-radius: 30px;
      opacity: 1;
      position: absolute;
      left: 0;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  `}
`

export const RadioLabelWrapper = styled.label`
  cursor: pointer;
  margin: 0;
`

export const RadioWrapper = styled.div`
  ${RadioInput} {
    &:checked + label {
      &:before {
        opacity: 1;
      }
      ${props => (props.imgRadio
    ? css`
      &:after {
        content: '';
        background-color: rgba(163, 142, 99, 0.1);
        position: absolute;
        top: 0;
        bottom: 0;
        left: -32px;
        right: -32px;
        transform: translateY(0);
        line-height: 0;
      }
      &:before {
        content: '';
        font-family: 'Font Awesome 5 Pro';
        font-weight: 300;
        font-size: 30px;
        color: ${theme.color.offWhite};
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: inset 0 0 0 1000px RGBA(163, 142, 99, 0.7);
      }
    `
    : css`
      border: 1px solid ${theme.color.black};
    `
  )}
    }
  }
  ${RadioLabel} {
    ${props => props.imgRadio && css`
      width: 63px;
      height: 63px;
      border: none;
    `}
  }
`

export const RadioTextLabel = styled(Label)`
  white-space: pre-line;
  font-family: ${theme.fonts.family.normal};
`

export const Divider = styled(DividerAnt)`
  margin: ${props => props.margin && props.margin} !important;
  color: ${theme.color.purplishGrey} !important;
  > span {
    padding: 0 16px 0 0 !important;
    font-family: ${theme.fonts.family.normal};
  }
  :before {
    width: 0 !important;
  }
  .ant-divider-inner-text{
    padding: 0 16px 0 0;
  }
  :after {
    border-top: 1px solid ${theme.color.paleGrey} !important;
  }
`

export const TimeLabel = styled.label`
  border-bottom: 1px solid rgba(223, 223, 223, 0.5);
  padding: 24px 0;
  margin: 0 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  > i {
    opacity: 0;
  }
`

export const TimeWrapper = styled.div`
  position: relative;
  margin: 0 -32px;
  ${RadioInput} {
    &:checked + ${TimeLabel} {
      &:before {
        content: '';
        background-color: rgba(163, 142, 99, 0.1);
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
      }
      > i {
        opacity: 1;
      }
    }
  }
`

export const TimeListWrapper = styled.div`
  ${TimeWrapper} {
    &:last-child {
      ${TimeLabel} {
        border: none;
      }
    }
  }
`

export const IconRotate = styled.i`
  font-size: ${theme.fonts.size.subHeading};
  transform: rotate(-90deg);
  font-family: "Font Awesome 5 Pro";
  width: fit-content;
  color: ${theme.color.silver};
  margin: 0 0 16px;
`

export const BookingStatusWrapper = styled.div`
  text-align: center;
  padding: ${props => props.padding};
  border: ${props => props.border};
  font-size: ${theme.fonts.size.normal};
  font-family: ${theme.fonts.family.normal};
  font-weight: ${theme.fonts.style.light};
  white-space: pre-line;
`

export const StatusWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: ${props => props.color};
`

export const StatusText = styled(H4)`
  color: ${props => props.color};
  margin: ${props => props.margin};
  font-weight: ${theme.fonts.style.bold};
  font-family: ${theme.fonts.family.normal};
`

export const StatusIcon = styled(Icon)`
  color: ${props => props.color};
  margin: ${props => props.margin};
`

export const DividerConfirm = styled.hr`
  border-top: 1px solid ${theme.color.paleGrey};
  margin: ${props => (props.margin ? props.margin : '0')};
`

export const BarberImg = styled.div`
  width: 24px;
  height: 24px;
  background-image: url(${props => props.img});
  background-size: cover;
  background-position: top center;
  border-radius: 20px;
`

export const ConfirmDataSpaceBetweenWrapper = styled.div`
  margin: 24px 0;
  display: flex;
  ${media.mobileL`
    flex-direction: column;
    > div {
      margin: 0;
      &:last-child {
        margin: 24px 0 0;
      }
    }
  `}
`
export const TimeError = styled(P)`
  padding-left: 5px;
  color: ${theme.color.error};
`
export const DisabledTimeWrapper = styled(TimeWrapper)`
  background-color: ${theme.color.paleGrey};
`
export const ErrorIspreferenceMessage = styled(P)`
  color: ${theme.color.error};
  padding-top: 10px;
`

export const ErrorLinkTel = styled.a`
  color: ${theme.color.error};
  text-decoration: underline;
`

export const Text = styled(P)`
  ${media.tablet`
    display: block;
  `}
`

export default RadioInput



// WEBPACK FOOTER //
// ./src/pages/reserve/styled.js